<template>
    <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
    >
        <v-card>
            <v-card-title>
                <v-subheader>{{ $t('portfolios.form.data') }}</v-subheader>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-progress-linear :indeterminate="true" v-show="form.loading"></v-progress-linear>

            <v-card-text v-show="!form.loading">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-switch
                                v-model="client.isActive"
                                :label="'O cliente está ativo? (' + ((client.isActive) ? 'Sim' : 'Não') + ')'"
                                flat
                                inset
                            ></v-switch>
                        </v-col>
                        <v-col cols="9">
                            <v-text-field
                                v-model="client.name"
                                :label="$t('portfolios.form.name.label')"
                                :rules="form.rules.name"
                                required
                                filled
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="client.primaryEmail"
                                :rules="form.rules.email"
                                :label="$t('portfolios.form.primaryEmail.label')"
                                required
                                filled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="form.fieldMasks.commercialPhone"
                                :label="$t('portfolios.form.commercialPhone')"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                required
                                filled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="form.fieldMasks.cellPhone"
                                :label="$t('portfolios.form.cellPhone')"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                required
                                filled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea
                                required
                                filled
                                no-resize
                                :label="$t('portfolios.form.comments')"
                                v-model="client.comments"
                            ></v-textarea>
                        </v-col>

                        <v-col cols="12">
                            <v-subheader class="pa-0 font-weight-bold">
                                Contatos do Cliente
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="ma-2"
                                    small
                                    text
                                    @click.prevent="addClientField"
                                >
                                    <v-icon>add</v-icon> Adicionar
                                </v-btn>
                            </v-subheader>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-row v-for="(contact, index) in client.contacts" :key="index">
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="client.contacts[index].name"
                                label="Nome"
                                required
                                filled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="client.contacts[index].email"
                                label="Email"
                                required
                                filled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="form.fieldMasks.contacts[index].phone"
                                label="Telefone"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                required
                                filled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="client.contacts[index].jobtitle"
                                label="Cargo"
                                required
                                filled
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-btn
                                color="error"
                                block
                                text
                                @click.prevent="removeClientFields(index)"
                            >
                                Remover
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>
        </v-card>
    </v-form>
</template>

<script>
import API from '@/api'
import { mask } from 'vue-the-mask'

export default {
    name: 'form-client',
    metaInfo () {
        return {
            title: this.$t('portfolios.form.meta.title'),
            meta: [
                { name: 'description', content: this.$t('portfolios.form.meta.description') },
                { name: 'keywords', content: this.$t('portfolios.form.meta.keywords') }
            ]
        }
    },
    directives: {
        mask
    },
    data: function () {
        return {
            form: {
                isEdit: false,
                valid: false,
                rules: {
                    name: [
                        v => !!v || this.$t('portfolios.form.name.required'),
                        v => (v && v.length >= 3) || this.$t('portfolios.form.name.length')
                    ],
                    email: [
                        v => !!v || this.$t('portfolios.form.primaryEmail.required'),
                        v => /.+@.+/.test(v) || this.$t('portfolios.form.primaryEmail.test')
                    ]
                },
                loading: true,
                fieldMasks: {
                    commercialPhone: '',
                    cellPhone: '',
                    contacts: []
                }
            },
            client: {
                name: '',
                commercialPhone: '',
                cellPhone: '',
                isActive: true,
                comments: '',
                primaryEmail: '',
                contacts: []
            }
        }
    },
    mounted () {
        if (this.$route.params.id != null) {
            this.loadData()
        } else {
            this.form.loading = false
        }
    },
    computed: {
        formMethod () {
            return (this.$route.params.id != null)
        }
    },
    methods: {
        addClientField () {
            if (this.client.contacts) {
                this.form.fieldMasks.contacts.push({
                    phone: ''
                })
                this.client.contacts.push({
                    name: '',
                    email: '',
                    phone: '',
                    jobtitle: ''
                })
            }
        },
        removeClientFields (index) {
            this.form.fieldMasks.contacts.splice(index, 1)
            this.client.contacts.splice(index, 1)
        },
        loadData () {
            let endpoint = API.EndPoints.getClient
            let params = {
                objectId: this.$route.params.id
            }
            new API(endpoint, params).request().then(response => {
                this.client = Object.assign({}, response.data.result)
                this.form.fieldMasks.commercialPhone = this.client.commercialPhone
                this.form.fieldMasks.cellPhone = this.client.cellPhone
                if (this.client.contacts) {
                    for (let index = 0; index < this.client.contacts.length; index++) {
                        this.form.fieldMasks.contacts.push({
                            phone: this.client.contacts[index].phone
                        })
                    }
                }
                this.$forceUpdate()
                this.form.isEdit = true
                this.form.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        formatObject () {
            this.client.commercialPhone = this.$helpers.unmask(this.form.fieldMasks.commercialPhone)
            this.client.cellPhone = this.$helpers.unmask(this.form.fieldMasks.cellPhone)
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            this.client.parent = currentUserCompany?.parent?.objectId ?? currentUserCompany?.client?.objectId
            for (let index = 0; index < this.form.fieldMasks.contacts.length; index++) {
                this.client.contacts[index].phone = this.$helpers.unmask(this.form.fieldMasks.contacts[index].phone)
            }
            let params = JSON.stringify(this.client)
            return params
        },
        async save (boolean) {
            if (this.$refs.form.validate()) {
                this.form.valid = false
                if (boolean) {
                    this.update()
                } else {
                    this.create()
                }
            }
        },
        saveSuccess () {
            this.$router.push('/portfolios').catch(e => {})
        },
        create () {
            let endpoint = API.EndPoints.createCompany
            new API(endpoint, this.formatObject()).request()
                .then((response) => {
                    this.saveSuccess()
                }, (e) => {
                    alert(e.body.error)
                })
        },
        update () {
            let endpoint = API.EndPoints.updateClient
            new API(endpoint, this.formatObject()).request()
                .then((response) => {
                    this.saveSuccess()
                }, (e) => {
                    alert(e.body.error)
                })
        }
    }
}
</script>

<style lang="stylus" scoped>
  .input-height
    height 57px
    position relative
</style>
